
import { useState } from 'react';

const FloatingButtons = () => {
  const [showTooltip, setShowTooltip] = useState<string | null>(null);

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* WhatsApp Button */}
      <div className="relative">
        {showTooltip === 'whatsapp' && (
          <div className="absolute right-14 top-1/2 -translate-y-1/2 bg-white rounded-full px-4 py-2 shadow-lg border border-gray-100 whitespace-nowrap">
            <span className="text-sm text-gray-700">Chat on WhatsApp</span>
          </div>
        )}
        <a
          href="https://wa.me/254116252525"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer border-2 border-white"
          onMouseEnter={() => setShowTooltip('whatsapp')}
          onMouseLeave={() => setShowTooltip(null)}
        >
          <i className="ri-whatsapp-line text-white text-2xl"></i>
        </a>
      </div>

      {/* Phone Button */}
      <div className="relative">
        {showTooltip === 'phone' && (
          <div className="absolute right-14 top-1/2 -translate-y-1/2 bg-white rounded-full px-4 py-2 shadow-lg border border-gray-100 whitespace-nowrap">
            <span className="text-sm text-gray-700">Call Us</span>
          </div>
        )}
        <a
          href="tel:+254116252525"
          className="w-14 h-14 bg-blue-500 hover:bg-blue-600 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer border-2 border-white"
          onMouseEnter={() => setShowTooltip('phone')}
          onMouseLeave={() => setShowTooltip(null)}
        >
          <i className="ri-phone-line text-white text-2xl"></i>
        </a>
      </div>
    </div>
  );
};

export default FloatingButtons;
